export type SwapKeysAndValues<T extends Record<string, string>> = {
  [K in T[keyof T]]: {
    [P in keyof T]: T[P] extends K ? P : never;
  }[keyof T];
};


export function swapKeysAndValues<T extends Record<string, string>>(obj: T): SwapKeysAndValues<T> {
  return Object.entries(obj).reduce((acc, [ key, value ]) => {
    acc[value as keyof SwapKeysAndValues<T>] = key as keyof T;
    return acc;
  }, {} as SwapKeysAndValues<T>);
}
